// extracted by mini-css-extract-plugin
export default {"home-item":"ProductBreadCrumb_home-item__fSlz7"};